import React from 'react';
import { Col, Label, FormGroup, Progress, Button } from 'twyne-new.ui';

import Input from 'components/form/Input';


export default class Password extends React.Component {

  state = {
    colorBar: '',
    percentBar: 0,
    rules: {
      oneLowerCase: false,
      oneUpperCase: false,
      oneNumber: false,
      oneSymbol: false,
      isValidLength: false,
    },
    isValid: false,
    generatedPassword: false,
  }

  rulesLength = Object.keys(this.state.rules).length

  rulesLabels = {
    oneLowerCase: 'At least 1 lower character',
    oneUpperCase: 'At least 1 upper character',
    oneNumber: 'At least 1 numeric character',
    oneSymbol: 'At least 1 symbol ($@!%*?&)',
    isValidLength: 'Password must be longer than 8 characters'
  }

  hasLowerCase = (str) => {
    if (str)
      return (/[a-z]/.test(str));
    return false
  }

  hasUpperCase = (str) => {
    if (str)
      return (/[A-Z]/.test(str));
    return false
  }

  hasNumber = (str) => {
    if (str)
      return (/[0-9]/.test(str));
    return false
  }

  hasSymbol = (str) => {
    if (str)
      return (/[$@!%*?&]/.test(str));
    return false
  }

  lengthLimit = (str) => {
    if (str)
      return str.length >= 8
    return false
  }

  handleGeneratePassword = (length, upperCharQuantity, numbersQuantity, symbolsCharQuantity) => {
    const passwordLength = length+1 | 9
    const upperChar =  upperCharQuantity | 1
    const numbers =  numbersQuantity | 1
    const symbolsChar =  symbolsCharQuantity | 1

    const lowerCharArr = 'a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z'.split(',')
    const upperCharArr = 'A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z'.split(',')
    const numbersArr = '0,1,2,3,4,5,6,7,8,9'.split(',')
    const symbolsArr = '$,@,!,%,*,?,&'.split(',')

    const getRandom = array => array[Math.floor(Math.random() * array.length)]

    let password = '';
    if (upperChar) password = password.concat(getRandom(upperCharArr))
    if (numbers) password = password.concat(getRandom(numbersArr))
    if (symbolsChar) password = password.concat(getRandom(symbolsArr))

    for (let i = 1; i < passwordLength - 3; i++) {
      password = password.concat(getRandom(lowerCharArr))
    }

    password = password.split('').sort(() => 0.5 - Math.random()).join('')
    this.props.onChange(password)
    this.setState({
      ...this.state,
      colorBar: 'success',
      percentBar: 100,
      rules: true,
      isValid: true,
      generatedPassword: true,
      password
    })
  }

  handleChange = (evt) => {

    let value = evt.target.value
    this.props.onChange(value)

    let isValid = true
    let rules = {}
    Object.keys(this.state.rules).map(function (key, idx) {
      rules[key] = false
    });

    if (this.hasLowerCase(value))
      rules.oneLowerCase = true
    isValid = isValid && this.hasLowerCase(value)

    if (this.hasUpperCase(value))
      rules.oneUpperCase = true
    isValid = isValid && this.hasUpperCase(value)

    if (this.hasNumber(value))
      rules.oneNumber = true
    isValid = isValid && this.hasNumber(value)

    if (this.hasSymbol(value))
      rules.oneSymbol = true
    isValid = isValid && this.hasSymbol(value)

    if (this.lengthLimit(value))
      rules.isValidLength = true
    isValid = isValid && this.lengthLimit(value)

    const hits = Object.values(rules).filter(Boolean).length
    const percentBar = hits * 100 / this.rulesLength

    let colorBar = 'warning'
    if (percentBar <= 25) {
      colorBar = 'danger'
    }

    if (percentBar == 100) {
      colorBar = 'success'
    }

    this.setState({
      colorBar,
      percentBar,
      rules,
      isValid,
      generatedPassword: false,
      password: value
    })

  }

  render() {

    return <React.Fragment>
      <Col size="6">
        <FormGroup>
          <Label>Password</Label>
          <Input
            name='password'
            type={this.state.generatedPassword ? 'text' : 'password'}
            value={this.state.password || ''}
            onChange={this.handleChange}
            validations={{ isValid: () => this.state.isValid }}
            required={this.props.required}
          />
        </FormGroup>
        <FormGroup>
          <Label>Confirm password</Label>
          <Input
            name="confirm_password"
            type='password'
            value={this.state.generatedPassword ? this.state.password  : ''}
            validations={{ sameAsPassword: (_, value) => { return value == this.state.password } }}
            validationErrors={{ sameAsPassword: 'Password confirmation must match password' }}
            required={!this.state.generatedPassword}
            disabled={this.state.generatedPassword}
          />
        </FormGroup>
      </Col>
      <Col size="6">
        <FormGroup>
          <div>Use the list below to set a strong password or click</div>
          <Button className='w-fit' variant='light' color='accent' size='sm' onClick={() => this.handleGeneratePassword()}>
            Generate password
          </Button>
          <Progress color={this.state.colorBar} value={this.state.percentBar} />
          {Object.entries(this.rulesLabels).map(([key, message], idx) => {
            return <div key={idx} className='row'>
              <span>{this.state.rules[key] ? <s>{message}</s> : message}</span>
            </div>
          })}
        </FormGroup>
      </Col>
    </React.Fragment >
  }
}